module.exports = __webpack_public_path__ + "img/pg3_bg.022373cb.png";